import React from 'react';
import { trackPixel } from '../../lib/metaPixel';
import { OFFER_URL } from '../../lib/clickMagick';
import { CTA_LABEL } from '../../data/presellContent';
type CtaButtonProps = {
  supportingText?: string;
  size?: 'default' | 'large';
};

/**
 * Shared presentation for the offer CTA.
 *
 * The click behavior is intentionally identical to the previously working CTA:
 * it fires the Meta Pixel ViewContent event and then performs exactly one
 * navigation to OFFER_URL, letting ClickMagick register the action and handle
 * the redirect to the vendor. Do not add further navigation here.
 */
export function CtaButton({
  supportingText = 'View the official presentation and decide for yourself',
  size = 'default'
}: CtaButtonProps) {
  const handleShowVSL = () => {
    trackPixel('ViewContent', {
      content_name: 'VSL Presentation'
    });
    window.location.href = OFFER_URL;
  };
  return <div className="w-full" data-id="element-2" data-mp="2o2lfazq74c8d">
      <button onClick={handleShowVSL} className={`w-full sm:w-auto bg-[#C2754E] hover:bg-[#A9623F] text-white font-bold rounded-xl shadow-lg hover:shadow-xl transition-colors duration-200 ease-out ${size === 'large' ? 'text-lg sm:text-xl py-5 px-8 sm:px-14' : 'text-base sm:text-lg py-4 px-8 sm:px-10'}`} data-id="element-3" data-mp="2o19zu2ne1g1f">
        {CTA_LABEL}
      </button>
      {supportingText && <p className="mt-4 text-sm text-[#8A9A8F]" data-id="element-4" data-mp="ukr0k7l5z3ex">{supportingText}</p>}
    </div>;
}